import { Button, type ButtonProps } from '@sevenrooms/ui-kit/form'
import { Text } from '@sevenrooms/ui-kit/typography'

interface LinkButtonProps extends ButtonProps {
  text: string
  onClick?: () => void
}

export function LinkButton({ text, onClick, ...props }: LinkButtonProps) {
  return (
    <Button noPadding variant="tertiary" onClick={onClick} {...props}>
      <Text color="primaryFont" textDecoration="underline">
        {text}
      </Text>
    </Button>
  )
}
